import React, { Fragment } from 'react';
import HighlightOffOutlined from '@material-ui/icons/HighlightOffOutlined';
import config from '../config';
import { draftJsToTipTap, parseToHtml } from '../utils/parseToHTML';


const ResultsFullAssessmentRequired = ({ customTitle, customDescription, resetAssessment }) => {
  const convertContent = (content) => {
    let contentState = JSON.parse(content);
    if(contentState.blocks) {
      contentState = draftJsToTipTap(contentState);
    }
    const html = parseToHtml(contentState);
    return html;
  };

  return (
    <Fragment>
      <div className="row">
        <div className="col-10 offset-2 d-flex align-items-center">
            {customTitle !== ''
              ? <h1 className="gw__results-title">{customTitle}</h1>
              : <h1 className="gw__results-title">Full assessment required</h1>
            }
            <HighlightOffOutlined className="gw__results-failure" />
        </div>
        <div className="col-10 offset-2">
          {customDescription !== ''
            ? <p className="gw__results-subtext pt-3 pb-4" dangerouslySetInnerHTML={{ __html: convertContent(customDescription) }}></p>
            : <p className="gw__results-subtext pt-3 pb-4">
              The candidate's position needs a detailed review by an immigration specialist to determine work eligibility.
              Please <a href={config.resultsFullAssessmentRequiredMailTo}>contact us</a> to request a detailed assessment including details of the hiring or assignment/transfer
              location for your candidate and our team will let you know what information they require to proceed.
            </p>
          }
        </div>

        <div className="col-10 offset-1 d-flex justify-content-around">
          <button className="btn btn-primary" onClick={resetAssessment}>CLOSE</button>
        </div>
      </div>
    </Fragment>
  );
};

export default ResultsFullAssessmentRequired;
